import querystring from 'querystring';
import xss from 'xss';

export function toUrlParams(config) {
    let params = [];

    for (const key in config.styles) {
        params.push(key + "=" + encodeURIComponent(config.styles[key]));
    }

    if(config.images) {
        if(config.images['PAGE__background-image']) {
            params.push('PAGE__background-image='+encodeURIComponent(config.images['PAGE__background-image']));
            params.push('PAGE__background-image-dim='+encodeURIComponent(config.images['PAGE__background-image-dim']));
        }
    }

    if(config.partnerSlug) {
        params.push('GLOBAL__PARTNER__SLUG='+encodeURIComponent(config.partnerSlug));
        params.push('GLOBAL__PARTNER__URL='+encodeURIComponent(config.partnerUrl));
    }

    return params.join("&");
}

export function scrollToTop() {
    if(document.getElementById("checkout-wrap")) {
        document.getElementById("checkout-wrap").scrollTo(0,0);
    }
}

export function serializeToUrl(object) {
    return querystring.stringify(object);
}

export function printToSidekick(apiUrl, reservationId, sidekick) {
    let req = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/plain; charset=ISO-8859-1',
        },
    };

    return fetch(apiUrl+'/kiosks/ticketLayout/'+reservationId, req).then((res) => {
        if(res.status === 200) {
            return res.text();
        }
    }).then((response) => {
        sidekick.printFromSettings(
            {
                auto_forward: true,
                double_receipt: false,
            },
            {
                kind: 'receipt',
                content: response,
                success: function() {
                },
                error: function(xhr) {
                },
                submit: function() {
                }
            }
        );
    }).catch((e) => {
        console.warn(e);
    });
}

export function getErrorText(e) {
    if(!Array.isArray(e)) {
        e = [e];
    }

    let msg = "";

    for(let i = 0; i < e.length; i++) {
        if(typeof e[i] === "string") {
            msg = e[i];
            break;
        } else if(typeof e[i] === "object" && e[i] !== null) {
            msg = e[i].detail;
        }
    }

    return msg;
}

export function getXssFilter() {
    const options = {
        whiteList: {
            p: ["style"],
            span: ["style"],
            a: ["href", "style", "target"],
            li: ["style"],
            ul: ["style"],
            ol: ["style"],
            table: ["style", "border"],
            caption: ["style"],
            tbody: ["style"],
            th: ["style"],
            tr: ["style"],
            td: ["style"],
            img: ["style", "src", "alt", "width", "height"],
            em: [],
            strong: [],
            br: [],
            h1: ["style"],
            h2: ["style"],
            h3: ["style"],
            h4: ["style"],
            h5: ["style"],
            h6: ["style"],
            sup: [],
            sub: [],
            blockquote: [],
            div: [],
            pre: [],
            code: [],
            center: [],
            iframe: ["src", "width", "height", "frameborder", "allowfullscreen", "data-mce-fragment"]
        },
        css: {
            whiteList: {}
        }
    }

    options.css.whiteList['text-align'] = true;
    options.css.whiteList['text-decoration'] = true;
    options.css.whiteList['padding-left'] = true;
    options.css.whiteList['border-collapse'] = true;
    options.css.whiteList['width'] = true;
    options.css.whiteList['height'] = true;

    return new xss.FilterXSS(options);
}
